// GENERATED FILE, PLEASE DO NOT EDIT
export var FontFamilies = {
  SansSerif: 'TTNorms',
  Serif: 'SourceSerifPro'
};